module.exports = __webpack_public_path__ + "static/media/hero-bus.fa13e931.jpg";